export const GET_LIST = 'ordersList/GET_LIST';
export const GET_LIST_DONE = 'ordersList/GET_LIST_DONE';
export const CHANGE_PAGE = 'ordersList/CHANGE_PAGE';
export const CHANGE_PAGE_SIZE = 'ordersList/CHANGE_PAGE_SIZE';
